import api from "../../../../../features/auth/axiosConfig";

export const getCarOrders = async (
  page: number,
  rowsPerPage: number,
  searchTerm: string,
  filter: string,
  selectedDate: string,
  selectedDate2: string
) => {
  const params: Record<string, string | number> = {
    pageNumber: page,
    pageSize: rowsPerPage,
    searchBy: searchTerm,
    dateFilter: filter === "CustomizeDate" ? "custom" : filter.toLowerCase(),
  };

  if (filter === "CustomizeDate" && selectedDate && selectedDate2) {
    params.startDate = selectedDate;
    params.endDate = selectedDate2;
  }

  const response = await api.get(`/app/pos/v2/order`, {
    params,
  });
  
  return response.data;
};

export const exportCarOrdersCSV = async (query: string) => {
  return await api.get(`/app/v2/import_export?export=csv&${query}`);
};

export const exportCarOrdersPDF = async (query: string) => {
  return await api.get(`/app/v2/import_export?export=pdf&${query}`);
};